<template lang="pug">
  ValidationObserver(v-slot="{ invalid, handleSubmit }" ref="validator")
    //- v-btn(color="primary" @click="test") test
    v-form.px-sm-0.px-md-10.pb-0.pb-sm-2.pb-md-4(@submit.prevent="handleSubmit(submitDataForm)")
      v-container(fluid)
        v-row
          v-col(cols="12")
            BaseSelectField(rules="required", :items="operatorsListWithCL" v-model="form.operator", :label="translations.label.operator" @input="changeOperator")
        v-row
          v-col(cols="12")
            BaseSelectField(rules="required", :items="providerListAll" v-model="form.provider", :label="translations.label.provider" @input="selectProvider")
            //- p Mostrar Proveedores (con freerounds activo), sólo se puede elegir 1
            //- p(v-if="providerSelected") {{ providerSelected.freerounds }}

        //- Juegos
        v-row(v-if="providerSelected && providerSelected.freerounds && providerSelected.freerounds.multiGame")
          v-col(cols="12")
            BaseAutocompleteEmptyField(rules="required", :items="gamesListAll" v-model="form.games", :label="translations.label.games")
          v-col.py-0(cols="12")
            FreespinsGameSimpleCardGroup(v-model="form.games")
        v-row(v-else-if="providerSelected && providerSelected.freerounds")
          v-col(cols="12")
            BaseChipSelectField(rules="required", :multiple="false", :items="gamesListAll" v-model="form.game", :label="translations.label.games")
        v-row(v-else)
          v-col(cols="12")
            BaseChipSelectField(rules="required" :label="translations.label.games" disabled)

        //- Usuarios
        v-row(v-if="providerSelected && providerSelected.freerounds && providerSelected.freerounds.multiUser")
          v-col(cols="12")
            v-switch(v-model="usersAll")
              template(v-slot:label)
                span(v-if="usersAll")
                  | {{ translations.label.selection }}: {{ translations.label.manual }} | 
                  strong {{ translations.label.all }}
                span(v-else)
                  | {{ translations.label.selection }}: 
                  strong {{ translations.label.manual }}
                  |  | {{ translations.label.all }}
          v-col(cols="12")
            BaseChipSelectField(:rules="{required: !usersAll}", :items="usersListAll" v-model="form.users", :label="translations.label.users", :disabled="usersDisable" name="users")
        v-row(v-else-if="providerSelected && providerSelected.freerounds")
          v-col(cols="12")
            BaseChipSelectField(rules="required", :multiple="false", :items="usersListAll" v-model="form.user", :label="translations.label.users")
        v-row(v-else)
          v-col(cols="12")
            BaseChipSelectField(rules="required" :label="translations.label.users" disabled)

        v-row
          v-col(cols="12" sm="6")
            BaseTextField(rules="required" v-model="form.externalId", :label="translations.label.externalId")
          v-col(cols="12" sm="6")
            BaseDatePickerRange(rules="required" v-model="form.daterange", :label="translations.label.daterange")
          v-col(cols="12" sm="6")
            BaseTextField(rules="required|numeric|min_value:0" v-model="form.amount", :label="translations.label.amount")
        //- parámetros de configuración antiguos
        //- v-row
        //-   v-col(cols="12").py-4
        //-     v-expansion-panels(accordion)
        //-       v-expansion-panel
        //-         v-expansion-panel-header
        //-           p.title.ma-0 {{ translations.label.extrafields }}
        //-         v-expansion-panel-content
        //-           v-divider.mb-4
        //-           BaseDynamicField(v-model="form.params" ref="dynamicField")

        //- parámetros de configuración nuevos, provienen del formulario dinámico generado en providers
        v-row(v-if="providerSelected && providerSelected.freerounds.fields != undefined")
          v-col(cols="12").py-4
            fieldset.fantasy__fieldset--basic
              legend {{ translations.label.extrafields }}
              v-row
                //- v-col.py-0(cols="12" sm="6" md="4")
                //- p {{ counter }}
                v-col.py-0(v-for="(field, ind) in providerSelected.freerounds.fields" :key="ind" cols="12" sm="6" md="4")
                  //- p {{ field }}
                  BaseTextField(v-if="field.type === 'string' || field.type === 'number'"
                    :rules="getRules(field)"
                    :label="field.label"
                    v-model="form.customFields[field.name]"
                    :name="field.name")
                  BaseDatePicker(v-else-if="field.type === 'date'"
                    :rules="getRules(field)"
                    :label="field.label"
                    v-model="form.customFields[field.name]"
                    :name="field.name")
                  BaseSelectField(v-else-if="field.type === 'select'"
                    :rules="getRules(field)"
                    :label="field.label"
                    :name="field.name"
                    v-model="form.customFields[field.name]"
                    :items="field.items")
            //- p {{ form.customFields }}

          //- parámetros de URL antiguos
          //- v-col(cols="12").py-4
          //-   v-expansion-panels(accordion)
          //-     v-expansion-panel
          //-       v-expansion-panel-header
          //-         p.title.ma-0 {{ translations.label.extrafieldsHidden }} UR
          //-       v-expansion-panel-content
          //-         v-divider.mb-4
          //-         BaseDynamicField(v-model="form.launcherParams" ref="dynamicFieldHidden")
          v-col(cols="12").my-0.py-0
            v-btn.float-right(:disabled="invalid"
              color="primary"
              type="submit"
              :loading="loadingCreate") {{ translations.button.send }}

</template>

<script>

  import FreespinsGameSimpleCardGroup from '@/components/cards/FreespinsGameSimpleCardGroup';
  import { mockFields } from '../mockup.js';

  export default {
    name: "FreeroundsCreate",
    components: {
      FreespinsGameSimpleCardGroup,
    },
    props:{
      clearForm: {
        type: Boolean,
        default: false
      },
      translations: {
        type: Object,
        default: function(){
          return {}
        }
      },
    },
    data:() =>({
      form:{
        operator: null,
        provider: null,
        daterange: [],
        amount: null,
        games: [],
        game: null,
        users: [],
        user: null,
        externalId: '',
        customFields: {},
        params: [],
        launcherParams: [],
      },
      usersAll: false,
      providerSelected: null,
    }),
    computed:{
      loadingCreate() {
        return this.$store.state.statusCode.createFreerounds.loading;
      },
      stateCreate() {
        return this.$store.state.statusCode.createFreerounds.state;
      },
      gamesListAll() {
        return this.$store.state.games.map(operator => ({
          text: operator.n,
          value: operator._id
        }));
      },
      operatorsListWithCL() {
        return this.$store.state.operators
        // .filter(operator => operator.cfg != undefined && operator.cfg.cl)
        .map(operator => ({
          text: operator.n,
          value: operator._id
        }));
      },
      providerListAll(){
        // return this.$store.state.providers;
        // TODO, pendiente mostrar los proveedores que tengan clf o clw activos
        return this.$store.state.providers.map(provider => ({
          text: provider.n,
          value: provider._id
        }));
      },
      usersListAll() {
        if(this.$store.state.users.docs != undefined){
          return this.$store.state.users.docs.map(user => ({
            text: `${user.r} - ${user.un}` ,
            value: user._id,
          }));
        } else {
          return [];
        }
      },
      usersDisable() {
        if(this.form.operator != null && this.usersListAll.length > 0 && !this.usersAll){
          return false;
        } else {
          return true;
        }
      },
    },
    watch: {
      clearForm: function(val){
        if (val){
          this.clearFields();
          this.$refs.validator.reset();
        }
      },
      stateCreate: function(val){
        if (val == 200) {
          this.$emit('successCreate');
        }
      },
      usersAll: function(val){
        if (val) {
          this.form.users = [];
        }
      },
    },
    created(){
      this.$store.dispatch('getGames');
      this.$store.dispatch('getOperators');
      this.$store.dispatch('getProviders');
    },
    methods:{
      test(){
        console.log(this.$store.state.operators);
        // debugger; // eslint-disable-line
      },
      removeGame(id){
        this.form.games = this.form.games.filter((game)=>{
          return game.value != id;
        });
      },
      changeOperator(){
        this.form.users = [];

        // debugger //eslint-disable-line
        // this.$refs.validator.refs.users.reset()

        let userParams = {
          offset: 0,
          limit: 50,
          operator: this.form.operator,
          id: '',
          start: '',
          end: '',
        };
        this.$store.dispatch('getUsers',userParams);
      },
      selectProvider(){
        let test = this.$store.state.providers.find(provider => provider._id === this.form.provider);
        test['freerounds'] = {          // TODO, quitar este mockup
          multiGame: true,
          multiUser: true,
          fields: mockFields,
        };
        this.providerSelected = test;

        this.providerSelected.freerounds.fields.forEach(field => {
          this.form.customFields[field.name] = null;
        });
      },
      getRules(field){
        let rules = '';
        if (field.validators != undefined){
          if(field.validators.required){
            rules = 'required';
          }
          if(field.type === 'number'){
            rules = rules.length ? rules + '|' : rules;
            rules += 'numeric';
          }
          if(field.validators.min_value){
            rules = rules.length ? rules + '|' : rules;
            rules += `min_value:${field.validators.min_value}`;
          }
          if(field.validators.max_value){
            rules = rules.length ? rules + '|' : rules;
            rules += `max_value:${field.validators.max_value}`;
          }
          if(field.validators.host){
            rules = rules.length ? rules + '|' : rules;
            rules += 'host';
          }
          if(field.validators.email){
            rules = rules.length ? rules + '|' : rules;
            rules += 'email';
          }
        }
        return rules;
      },
      getDateIsoString(date){
        const [day, month, year] = date.split('/');
        return new Date(year, month - 1, day).toISOString();
      },
      submitDataForm(){
        let gamesSelected = this.form.games.length ? this.form.games.map((game)=> game.value) : [this.form.game.value];
        let formSend = {
          data: {
            operator: this.form.operator,
            provider: this.form.provider,
            startdate: this.getDateIsoString(this.form.daterange[0]),
            enddate: this.getDateIsoString(this.form.daterange[1]),
            amount: this.form.amount,
            games: gamesSelected,
            externalId: this.form.externalId,
            customFields: {...this.form.customFields},
          }
        };
        if(this.usersAll){
          formSend.data.usersAll = true;
        } else if(this.form.users.length){
          formSend.data.users = this.form.users.map((user)=>(user.value));
        } else {
          formSend.data.users = [this.form.user.value];
        }
        if (this.form.params.length){
          formSend.data.params = {};
          this.form.params.forEach((item) => {
            formSend.data.params[item.key] = item.value
          });
        }
        if (this.form.launcherParams.length){
          formSend.data.launcherParams = {};
          this.form.launcherParams.forEach((item) => {
            formSend.data.launcherParams[item.key] = item.value
          });
        }
        console.log(formSend);
        console.log(this.form.customFields);
        // this.$store.dispatch('createFreerounds', formSend);
      },
      clearFields(){
        this.form.operator = null;
        this.form.provider = null;
        this.form.daterange = [];
        this.form.amount = null;
        this.form.games = [];
        this.form.users = [];
        this.usersAll = false;
        this.form.externalId = '';
        this.form.customFields = {};
        this.form.params = [];
        this.form.launcherParams = [];
        if(this.$refs != undefined && this.$refs.dynamicField != undefined){
          this.$refs.dynamicField.clear();
        }
        if(this.$refs != undefined && this.$refs.dynamicFieldHidden != undefined){
          this.$refs.dynamicFieldHidden.clear();
        }
      },
    }
  }
</script>

<style lang="sass">
</style>